import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp } from 'lucide-react';

import styles from './faq.module.scss';

/**
 * Accordion with the first answer open. Closed answers stay in the server-rendered
 * HTML (`hidden`), so the visible FAQ matches the FAQPage JSON-LD.
 */
const FaqAccordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const idPrefix = useId();

  return (
    <ul className={styles.list}>
      {items.map(({ question, answer }, index) => {
        const open = index === openIndex;
        const answerId = `${idPrefix}-answer-${index}`;
        const Chevron = open ? ChevronUp : ChevronDown;

        return (
          <li key={question} className={styles.item}>
            <h3 className={styles.question}>
              <button
                type="button"
                aria-expanded={open}
                aria-controls={answerId}
                onClick={() => setOpenIndex(open ? null : index)}
              >
                {question}
                <span className={styles.toggle} aria-hidden="true">
                  <Chevron size={22} />
                </span>
              </button>
            </h3>
            {/* Trusted HTML from the app's own content, the same string as in the JSON-LD. */}
            <div
              id={answerId}
              className={styles.answer}
              hidden={!open}
              dangerouslySetInnerHTML={{ __html: answer }}
            />
          </li>
        );
      })}
    </ul>
  );
};

FaqAccordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ question: PropTypes.string, answer: PropTypes.string }),
  ).isRequired,
};

export default FaqAccordion;
